// 负责当前选中商品详情展示，与尺码选择和加入购物车交互关联。
import { Plus } from "lucide-react";
import { formatCurrency } from "../../domain/cart";
import type { Product } from "../../domain/products";

type ProductDetailProps = {
  product: Product;
  selectedSize: string;
  onSelectSize: (size: string) => void;
  onAddSelectedProduct: () => void;
};

export const ProductDetail = ({
  product,
  selectedSize,
  onSelectSize,
  onAddSelectedProduct
}: ProductDetailProps) => {
  return (
    <article className="product-detail" aria-label="Selected product">
      <img src={product.imageUrl} alt={product.name} />
      <div className="detail-content">
        <div>
          <p>{product.category}</p>
          <h2>{product.name}</h2>
          <div className="price-row">
            <strong>{formatCurrency(product.price)}</strong>
            {product.compareAtPrice ? (
              <span>{formatCurrency(product.compareAtPrice)}</span>
            ) : null}
          </div>
        </div>

        <div className="tag-row">
          {product.tags.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>

        <div className="size-picker">
          <span>Size</span>
          <div>
            {product.sizes.map((size) => (
              <button
                className={selectedSize === size ? "active" : ""}
                type="button"
                key={size}
                onClick={() => onSelectSize(size)}
              >
                {size}
              </button>
            ))}
          </div>
        </div>

        <dl className="product-notes">
          <div>
            <dt>Fit</dt>
            <dd>{product.fitNote}</dd>
          </div>
          <div>
            <dt>Material</dt>
            <dd>{product.material}</dd>
          </div>
          <div>
            <dt>Color</dt>
            <dd>{product.color}</dd>
          </div>
        </dl>

        <button
          className="primary-button"
          type="button"
          onClick={onAddSelectedProduct}
        >
          <Plus aria-hidden="true" size={19} />
          Add to bag
        </button>
      </div>
    </article>
  );
};
